import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import CategorySection from "./components/CategorySection";
import FeatureEditorials from "./components/FeatureEditorials";
import SubmitSection from "./components/SubmitSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50 shadow-soft transition-all hover:bg-primary-600 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line" aria-hidden="true" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <CategorySection />
        <FeatureEditorials />
        <SubmitSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}